import CRUDService from "./CRUDService";
class CommentAdminViewService extends CRUDService {
    constructor() {
        super("comment-admin-view");
    }
}

export default new CommentAdminViewService();
